import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './tripAddresses.actions.js';
import getters from './tripAddresses.getters.js';
import mutations from './tripAddresses.mutations.js';
import state from './tripAddresses.state.js';

BaseStore.registerModule('tripAddresses', {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('tripAddresses');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
